import React from 'react';
import { AgGridReact } from 'ag-grid-react';
import {
	ApLoaderDefault,
	ApLoaderText,
	ApButtonSecondary,
} from '@alixpartners/ui-components';
import { PERMISSIONS, PermissionsContext } from 'contexts/PermissionsContext';
import ContextualMenu from 'Details/ContextualMenu';
import {
	MenuWrapper,
	Wrapper,
	TableWrapper,
	ShowMoreWrapper,
	NoData,
	LoaderWrapper,
} from './CommonVendorsTable.styles';
import { agGridRowSelector } from '../../utils';
import CategoriesCellRenderer from '../../ShareOfTotalSpendSection/CategoriesCellRenderer';

const HEADER_HEIGHT = 30;
const ROW_HEIGHT = 24;

export class CommonVendorsTableView extends React.Component {
	state = {
		isMenuOpen: false,
		hoveredRowIndex: null,
	};
	gridApi = null;

	componentDidUpdate(prevProps) {
		const { isLoading } = this.props;

		if (isLoading !== prevProps.isLoading) {
			if (isLoading) {
				this.showLoadingOverlay();
			} else {
				this.hideLoadingOverlay();
			}
		}
	}

	onGridReady = params => {
		this.gridApi = params.api;
		params.api.sizeColumnsToFit();
	};

	handleSortChange = () => {
		const { onSortChanged } = this.props;

		if (!this.gridApi) {
			return;
		}

		onSortChanged(this.gridApi.getSortModel());
	};

	showLoadingOverlay = () => {
		if (!this.gridApi) {
			return;
		}

		this.gridApi.showLoadingOverlay();
	};

	hideLoadingOverlay = () => {
		if (!this.gridApi) {
			return;
		}

		this.gridApi.hideOverlay();
	};

	toggleContextualMenu = () => {
		const { isMenuOpen } = this.state;
		this.setState({ isMenuOpen: !isMenuOpen });
	};

	hideContextualTrigger = () => {
		const { isMenuOpen } = this.state;
		if (!isMenuOpen) {
			this.setState({ hoveredRowIndex: null });
		}
	};

	hideContextualMenu = () => {
		this.setState({ isMenuOpen: false });
	};

	getGridOptions = () => {
		const { data, columnDefs } = this.props;
		const { isMenuOpen, hoveredRowIndex } = this.state;

		return {
			defaultColDef: {
				suppressMenu: true,
				// Prevent default sorting, as we handle sorting on server side
				comparator: () => 0,
			},
			frameworkComponents: {
				categoriesCellRenderer: CategoriesCellRenderer,
			},
			rowData: data,
			rowHeight: ROW_HEIGHT,
			headerHeight: HEADER_HEIGHT,
			columnDefs,
			suppressCopyRowsToClipboard: true,
			suppressScrollOnNewData: true,
			suppressRowDrag: true,
			suppressRowClickSelection: true,
			suppressCellSelection: true,
			suppressCsvExport: true,
			suppressExcelExport: true,
			suppressContextMenu: true,
			suppressMultiSort: true,
			applyColumnDefOrder: true,
			domLayout: 'autoHeight',
			onGridReady: this.onGridReady,
			onCellMouseOver: params => {
				const row = document.querySelectorAll(
					agGridRowSelector(params.rowIndex)
				)[0];
				if (row && params.rowIndex !== hoveredRowIndex && !isMenuOpen) {
					this.setState({ hoveredRowIndex: params.rowIndex });
				}
			},
			onSortChanged: this.handleSortChange,
			onRowDataChanged: params => {
				params.api.sizeColumnsToFit();
			},
		};
	};

	render() {
		const {
			data,
			loadMore,
			isLoading,
			showCategorisationModal,
			onViewTransactionsClick,
			onChangeStatus,
			onMoveToBin,
			permissions,
			totalCount,
		} = this.props;
		const { isMenuOpen, hoveredRowIndex } = this.state;
		const hasWritePermissions =
			permissions && permissions.includes(PERMISSIONS.TransactionsWrite);

		return (
			<Wrapper onMouseLeave={this.hideContextualTrigger}>
				{isLoading && data.length === 0 ? (
					<LoaderWrapper>
						<ApLoaderDefault loaderText={() => <ApLoaderText />} />
					</LoaderWrapper>
				) : data.length === 0 ? (
					<NoData>No data available</NoData>
				) : (
					<React.Fragment>
						<TableWrapper>
							{data.map((row, index) => (
								<MenuWrapper
									top={HEADER_HEIGHT + index * ROW_HEIGHT}
									key={index}
								>
									{hoveredRowIndex === index && (
										<ContextualMenu
											onViewTransactions={() => {
												onViewTransactionsClick(row);
											}}
											onChangeCategorisation={() => {
												showCategorisationModal(row);
											}}
											hasWritePermissions={hasWritePermissions}
											onChangeStatus={() => onChangeStatus(row)}
											toggleMenu={this.toggleContextualMenu}
											moveToBin={() => onMoveToBin(row)}
											isOpen={hoveredRowIndex === index && isMenuOpen}
										/>
									)}
								</MenuWrapper>
							))}
							<div className="ag-theme-balham">
								<AgGridReact {...this.getGridOptions()} />
							</div>
						</TableWrapper>
						<ShowMoreWrapper>
							{totalCount !== data.length && (
								<ApButtonSecondary onClick={loadMore}>
									Show 10 more items
								</ApButtonSecondary>
							)}
						</ShowMoreWrapper>
					</React.Fragment>
				)}
			</Wrapper>
		);
	}
}

export const CommonVendorsTable = props => (
	<PermissionsContext.Consumer>
		{({ permissions }) => (
			<CommonVendorsTableView {...props} permissions={permissions || []} />
		)}
	</PermissionsContext.Consumer>
);
